export default __webpack_public_path__ + "static/media/background-6.bf4463a4.png";